import * as ko from 'knockout';
import { Observable, ObservableArray } from 'knockout';
import { cleaningService } from '../../../api/service.cleaning';
import { formatDateTime } from '../../../utils/format';
import { dialog } from '../../app';
import { DialogParams, FieldType } from '../../elements/bp-dialog';

class CleaningDashboard {
  readonly title: Observable<string>;
  readonly dialog: Observable<DialogParams | null>;

  readonly records: ObservableArray<any>;

  constructor(params: any) {
    this.title = ko.observable('Cleaning / Records');
    this.dialog = ko.observable(null);

    this.records = ko.observableArray();

    this.loadRecords();
    // load scheduled items that are due and not completed.
    // display these in a bar at the top of the page.
  }

  loadRecords = () => {
    cleaningService.getRecords()
      .then(results => {

        this.records(results.map(r => {
          return {
            equipmentLocation: `${r.location} / ${r.equipment}`,
            date: formatDateTime(r.createdTime),
            ...r,
          }
        }));
      })
      .catch(e => console.log(e));
  };

  actions = {
    createRecord: (): void => {

      // load data.
      const equipment = ko.observableArray();
      const tasks = ko.observableArray();

      cleaningService.loadEquipment()
        .then(results => {
          equipment([]);
          equipment(results);
        })

      const origMessage = 'Create new cleaning record';
      const message = ko.observable('');

      const model = {
        userPin: ko.observable(''),
        equipmentId: ko.observable(0),
        taskId: ko.observable(0),
        notes: ko.observable('')
      };

      model.equipmentId.subscribe(() => {
        if (model.equipmentId() === undefined || model.equipmentId() === 0) {
          tasks([]);
        }

        cleaningService.loadTasks(model.equipmentId())
          .then(results => {
            tasks([]);
            tasks(results);
          })
      })

      const userPinField: FieldType<string> = {
        title: 'User PIN',
        type: 'userPin',
        value: model.userPin,
        setFocus: true
      };

      const equipmentIdField: FieldType<any> = {
        title: 'Select Location / Equipment',
        type: 'searchable-dropdown',
        value: model.equipmentId,
        setFocus: true,
        filterText: ko.observable(''),
        options: equipment,
        optionsText: (o) => o && o.name,
        optionsValue: (o) => o && o.id,
        optionsCaption: ko.observable('-- Select --')
      };


      const taskIdField: FieldType<any> = {
        title: 'Select Task',
        type: 'searchable-dropdown',
        value: model.taskId,
        setFocus: true,
        filterText: ko.observable(''),
        options: tasks,
        optionsText: (o) => o && o.name,
        optionsValue: (o) => o && o.id,
        optionsCaption: ko.observable('-- Select --')
      };

      const notesField: FieldType<string> = {
        title: 'Notes',
        type: 'textarea',
        value: model.notes,
      };

      dialog({
        title: 'Create Record',
        message: message,
        fields: ko.observableArray([userPinField, equipmentIdField, taskIdField, notesField]),
        submitText: 'Submit',
        cancelText: 'Cancel',
        cancelAction: () => {
          dialog(null);
        },
        submitAction: () => {
          let errors = '';

          if (model.userPin() === '') {
            errors += 'User PIN is required. <br />';
          }

          if (model.equipmentId() === 0 || model.equipmentId() === undefined) {
            errors += 'Location and equipment is required. <br />';
          }

          if (model.taskId() === 0 || model.taskId() === undefined) {
            errors += 'A task is required. <br />';
          }

          if (errors !== '') {
            message(`${origMessage} <br><div class="error"> - ${errors}</div>`);
            return;
          }

          console.log(model.userPin());

          cleaningService.createLog(model.userPin(), model.taskId(), model.notes())
            .then(result => {
              if (result) {
                dialog(null);

                this.loadRecords();

              } else {
                message(origMessage + '<br><div class="error"> - Failed to create cleaning log.</div>');
              }
            });
        }
      });

    },

  };
}

export default {
  name: 'bp-cleaning',
  viewModel: CleaningDashboard,
  template: require('./dashboard.html')
};
